import "./style.css";

const Loading = () => {
	return <div className="loader-home"></div>;
};
export default Loading;
